<script>
export default {
    props: ['file', 'destinataires', 'size', 'disabled'],
    data() {
        return {}
    },
    computed: {
        sendToName() {
            if(this.file && this.file.hasOwnProperty('destinataire_id')) {
                const dest = this.destinataires.find(destinataire => destinataire.hasOwnProperty('id') && destinataire.id == this.file.destinataire_id)
                if(dest) {
                    return dest.id
                }
            }
            else if(this.file && this.file.destinataire && this.file.destinataire.length > 0 && this.file.destinataire[0].mail != 'all') {
                return this.file.destinataire[0].uid
            }            
            return 'tout le monde'
        },
        displayName() {
            if( this.file && this.file.destinataire && this.file.destinataire.length > 0 && this.file.destinataire[0].mail != 'all') {
                return this.file.destinataire[0].mail
            }
            return 'tout le monde'
        }
    }
}
</script>
<template>
    <b-dropdown
        class="dest-select"
        :class="{'tout-le-monde': sendToName == 'tout le monde'}"
        style="background-color: #E8B543"
        href="#"
        :size="size"
        :disabled="disabled"
        v-b-popover.hover.right="'Ce document sera envoyé à '+displayName">
        <template #button-content>
            <i v-if="sendToName == 'tout le monde'"
                class="fas fa-users cursorPointer"></i>
            <i v-else class="fas fa-user-tag cursorPointer"></i>                                                                            
        </template>
        <b-dropdown-item href="#"
            @click="$emit('destinataire-selected', {file, dest:{mail: 'all'}})"
            :class="{selectedDest: (sendToName == 'tout le monde')}">
            Tout le monde
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item v-for="(dest,destIndex) in destinataires" :key="'d'+destIndex"
            :class="{selectedDest: ( sendToName == dest.uid || sendToName == dest.id )}" href="#"
            @click="$emit('destinataire-selected', {file, dest})">
            {{ dest.prenom }} {{ dest.nom }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<style lang="scss">
    .tout-le-monde {
        .btn-secondary {
            color:#5894B4;
        }
    }
    .dest-select {
        .btn {
            background-color: #E8B543 !important;
            border-color: #E8B543 !important;
        }
        .selectedDest {
            background-color: #E8B543;
        }
        ul {
            max-height: 50vh;
            overflow-y: auto;
        }
    }
</style>